import DaftarItem from "./views/DaftarItem.vue";

const requireAuth = {requireAuth: true}

const DaftarItemRoute = {
    path: "/daftar_item/:idoutlet",
    name: "DaftarItem",
    component: DaftarItem,
    meta: {
        ...requireAuth,
        accessKey: 'item.read',
    },
}

export default router => {
    router.addRoutes([DaftarItemRoute])
}
